import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SquareContainer from './SquareContainer.jsx';
import { useNavigate, useLocation } from 'react-router-dom';
import { getLink } from "../../dataProvider/links.js";
import { verifyPasswords } from "../../dataProvider/password.js";
import { updateUser, getUserData } from "../../actions/user.js"
import { error as logError } from "../../logger.js";
import qs from 'qs'
import { connect } from "react-redux";

import emailIconV2 from "../../img/v2/contact/email.png";

import "../../scss/v2/user/passwordChange.scss"

function PasswordChange(props) {

    const { t, i18n } = useTranslation();
    const [password, setPassword] = useState('');
    const [verifyPassword, setVerifyPassword] = useState('');
    const [error, setError] = useState(null);
    let navigate = useNavigate();
    let location = useLocation();

    const handleSubmit = () => {
        setError(null)
        const error = verifyPasswords(password, verifyPassword);
        if (error) {
            setError(error);
            return;
        }

        const queryParamId = qs.parse(location.search, { ignoreQueryPrefix: true }).customerId;

        if (!props.user.id && !queryParamId) return navigate(getLink("login", i18n.language))

        props.dispatch(getUserData(queryParamId || props.user.id))
            .then(user => {
                const newMetadata = user.metadata || { biblio: {} };
                newMetadata.biblio.password = password
                return props.dispatch(updateUser({ id: user.id, metadata: newMetadata }))
            })
            .then(() => {
                navigate(getLink("login", i18n.language))
            })
            .catch(err => {
                setError("server")
                logError(err)
            })
    }

    return (
        <SquareContainer>
            <div className="passwordChange">
                <div className="row">
                    <div className="col-12 col-lg-6 offset-lg-3">
                        <h1 className="user-square-container-title">{t('passwordChange.title')}</h1>
                        <h2 className="user-square-container-subtitle">{t('passwordChange.subtitle')}</h2>
                        {error ? <div className="alert alert-danger">{t(`passwordChange.error.${error}`)}</div> : null}
                        <div className="user-square-container-input-group">
                            <p className="user-square-container-input-group-label">{t('passwordChange.label.password')}</p>
                            <input className="user-square-container-input-group-input" type="password" placeholder={t('passwordChange.placeholder.password')} onChange={(event) => { setPassword(event.target.value) }} />
                            <div className="user-square-container-input-group-left-icon">
                                <img className="img img-fluid user-square-container-input-group-left-icon-svg" src={emailIconV2} alt={emailIconV2} />
                            </div>
                        </div>
                        <div className="user-square-container-input-group">
                            <p className="user-square-container-input-group-label">{t('passwordChange.label.verifyPassword')}</p>
                            <input className="user-square-container-input-group-input" type="password" placeholder={t('passwordChange.placeholder.verifyPassword')} onChange={(event) => { setVerifyPassword(event.target.value) }} />
                            <div className="user-square-container-input-group-left-icon">
                                <img className="img img-fluid user-square-container-input-group-left-icon-svg" src={emailIconV2} alt={emailIconV2} />
                            </div>
                        </div>
                        <div className="text-center">
                            <button className="button orange-button" onClick={handleSubmit}>{t('passwordChange.submit')}</button>
                        </div>
                    </div>
                </div>
            </div>
        </SquareContainer>
    )

}

const mapStateToProps = (state) => ({ user: state.user.user });

const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(PasswordChange);